import React from 'react';
import { FiUser, FiPhone, FiMail } from 'react-icons/fi';
import styles from '../PaymentForm.module.css';
import { useGuestPayment } from './paymentApiContext';
import { formatPhoneNumber } from '../../../utils/formatting/phoneNumber';

// New students only (renders nothing for signed-in students): who is enrolling. The email
// came from the enrollment step; the rest is typed here and becomes their student account
// once payment succeeds. Locked while a payment is prepared so it can't drift from it.
export default function GuestDetailsCard({ locked }) {
  const guest = useGuestPayment();
  if (!guest) return null;

  const { email, details, setDetails, detailsError, changeEmail } = guest;
  const set = (field) => (e) => {
    const value = field === 'phone' ? formatPhoneNumber(e.target.value) : e.target.value;
    setDetails((d) => ({ ...d, [field]: value }));
  };

  return (
    <div className={styles.promoCard}>
      <h3 className={styles.promoCardTitle}><FiUser size={13} /> Your Information</h3>
      <div className={styles.guestFields}>
        <div className={styles.nameFields}>
          <input
            className={styles.promoCodeInput}
            type="text"
            placeholder="First name"
            autoComplete="given-name"
            value={details.firstName}
            onChange={set('firstName')}
            aria-label="First name"
            aria-required="true"
            disabled={locked}
          />
          <input
            className={styles.promoCodeInput}
            type="text"
            placeholder="Last name"
            autoComplete="family-name"
            value={details.lastName}
            onChange={set('lastName')}
            aria-label="Last name"
            aria-required="true"
            disabled={locked}
          />
        </div>
        <div className={styles.phoneField}>
          <span className={styles.phoneIcon} aria-hidden="true"><FiPhone size={16} /></span>
          <span className={styles.phonePrefix} aria-hidden="true">
            <span className={styles.phoneFlag}>🇺🇸</span>
            <span>+1</span>
            <span className={styles.phoneSeparator}>·</span>
          </span>
          <input
            className={styles.promoCodeInput}
            type="tel"
            inputMode="tel"
            maxLength={14}
            placeholder="Phone number"
            autoComplete="tel"
            value={details.phone}
            onChange={set('phone')}
            aria-label="Phone number"
            aria-required="true"
            disabled={locked}
          />
        </div>
        {detailsError && (
          <div className={styles.promoErrorMessage} role="alert">
            <div className={styles.promoErrorText}>{detailsError}</div>
          </div>
        )}
        <div className={styles.emailRow}>
          <span className={styles.emailAddress}><FiMail size={16} aria-hidden="true" /><span>{email}</span></span>
          <button
            className={styles.changeEmailButton}
            type="button"
            onClick={changeEmail}
            aria-label="Change email"
          >
            Change
          </button>
        </div>
      </div>
    </div>
  );
}
